<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';

export default {
    init: (payload) => {
        payload.filter();
    },
    methods:{
        filter: function(){
            let state = this;
            setTimeout(async function(){
              let trucker = (await Request.do(state, 'GET', Request.getDefaultHeader(state), null,`${Endpoints.reports.truck.withoutCertifie}`));
                if (trucker.status==200){
                    state.items = trucker.data.results;
                }
        }, 100);
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>